import { render, staticRenderFns } from "./ModalModeloImpressoPersonalizado.vue?vue&type=template&id=3d10e77c&scoped=true"
import script from "./ModalModeloImpressoPersonalizado.vue?vue&type=script&lang=ts"
export * from "./ModalModeloImpressoPersonalizado.vue?vue&type=script&lang=ts"
import style0 from "./ModalModeloImpressoPersonalizado.vue?vue&type=style&index=0&id=3d10e77c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d10e77c",
  null
  
)

export default component.exports